import posthog from "posthog-js";
import "posthog-js/dist/exception-autocapture";
import "posthog-js/dist/web-vitals";
import { scrubEvent } from "./scrubEvent";
import type { AnalyticsSink } from "./types";

export interface PostHogSinkOptions {
  host: string;
  key: string;
}

export function createPostHogSink(options: PostHogSinkOptions): AnalyticsSink {
  if (!posthog.__loaded) {
    posthog.init(options.key, {
      api_host: options.host,
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      capture_dead_clicks: false,
      capture_heatmaps: false,
      disable_surveys: true,
      advanced_disable_feature_flags: true,
      person_profiles: "never",
      disable_session_recording: true,
      capture_performance: { web_vitals: true, web_vitals_attribution: false },
      capture_exceptions: true,
      disable_external_dependency_loading: true,
      cross_subdomain_cookie: false,
      secure_cookie: true,
      before_send: scrubEvent,
      mask_personal_data_properties: true,
    });
    posthog.register({ $geoip_disable: true });
  }

  return {
    track(event, properties) {
      posthog.capture(event, properties);
    },
    register(properties) {
      posthog.register(properties);
    },
    unregister(key) {
      posthog.unregister(key);
    },
  };
}
